import styled from 'styled-components';
import { spacing } from 'ui/theme';
import { Module } from '../../lib/components/Module';
import { UserGreeting } from '../UserGreeting';
import { withLaunchpadProvider } from './contexts/LaunchpadProvider';
import { useLaunchpadState } from './hooks/useLaunchpadState';
import { LaunchpadContent } from './LaunchpadContent';
import { LaunchpadHeader } from './LaunchpadHeader';
import { LAUNCHPAD_TEST_IDS } from './Launchpad.constants';

export const LaunchpadModule = styled(Module)<{ $isDataState?: boolean }>`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: ${spacing.threeQuarter};

  && {
    padding: ${spacing.plusHalf} ${spacing.base};
  }

  ${({ $isDataState }) =>
    $isDataState &&
    `
    &&[data-size] {
      padding-bottom: 0;
    }
  `}
`;

export const Launchpad = withLaunchpadProvider(() => {
  const launchpadState = useLaunchpadState();
  const { isEmptyState, isDataState } = launchpadState;

  return (
    <LaunchpadModule
      data-test={LAUNCHPAD_TEST_IDS.MODULE}
      minHeight={isEmptyState || isDataState ? 'auto' : undefined}
      $isDataState={isDataState}
    >
      <UserGreeting />
      <LaunchpadHeader {...launchpadState} />
      <LaunchpadContent {...launchpadState} />
    </LaunchpadModule>
  );
});
